var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Events } from 'ionic-angular';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { ApiProvider, EmptySubscriber } from '../api/api';
import { CollectionActions } from '../../state/actions';
import { FillerShiftModel } from '../../models/filler-shift';
import { SessionProvider } from '../session/session';
import { UserModel } from '../../models/user';
export var UserEvent;
(function (UserEvent) {
    UserEvent["UserDidLogout"] = "userDidLogout";
    UserEvent["UserDidLogin"] = "userDidLogin";
})(UserEvent || (UserEvent = {}));
let UserProvider = UserProvider_1 = class UserProvider {
    constructor(api, session, store, collectionActions, events) {
        this.api = api;
        this.session = session;
        this.store = store;
        this.collectionActions = collectionActions;
        this.events = events;
        this.currentUser$ = new BehaviorSubject(null);
        this.isLoggedIn$ = new BehaviorSubject(null);
        this.currentFillerShift$ = new BehaviorSubject(null);
        this.load();
    }
    load() {
        this.session.get(UserProvider_1.USER_DATA_KEY).then(data => {
            let user = data ? new UserModel(data) : null;
            this.currentUser$.next(user);
        });
        this.session.get(UserProvider_1.AUTH_DATA_KEY).then(data => {
            this.api.authData = data;
            if (data) {
                this.isLoggedIn$.next(data != null);
                this.getUser();
            }
        });
    }
    // User
    login(phone, pin) {
        var response = this.api
            .call({
            url: '/sessions',
            method: 'POST',
            params: { phone: phone, pin: pin },
        })
            .flatMap(data => {
            return Observable.fromPromise(this.session.clear()).flatMap(() => {
                return this.setAuthData(data);
            });
        });
        response.subscribe(() => {
            this.getUser();
            this.isLoggedIn$.next(true);
            this.events.publish(UserEvent.UserDidLogin);
        }, error => {
            console.log('login error', error);
        });
        return response;
    }
    sendPin(phone) {
        return this.api.call({
            url: '/pin_send',
            method: 'POST',
            body: { phone: phone },
        });
    }
    loginWithAuthKey(auth_key, user_uid) {
        return this.setAuthData({ auth_key: auth_key, user_uid: user_uid }).then(() => {
            this.getUser();
            this.isLoggedIn$.next(true);
            this.events.publish(UserEvent.UserDidLogin);
        }, error => {
            console.log('error logging in', error);
        });
    }
    getUser() {
        let response = this.api
            .call({
            url: `/users/${ApiProvider.USER_UID}`,
            method: 'GET',
        })
            .map(result => new UserModel(result));
        response
            .do(data => {
            this.currentUser$.next(data);
            this.session.set(UserProvider_1.USER_DATA_KEY, data.json);
        })
            .subscribe(res => console.log(res), error => {
            if (error.status === 401) {
                this.logout();
                return null;
            }
        });
        return response;
    }
    updateUser(params) {
        let response = this.api
            .call({
            url: `/users/${ApiProvider.USER_UID}`,
            method: 'PATCH',
            body: params,
        })
            .map(result => new UserModel(result));
        response
            .do(data => {
            this.currentUser$.next(data);
            this.session.set(UserProvider_1.USER_DATA_KEY, data.json);
        })
            .subscribe(new EmptySubscriber());
        return response;
    }
    logout() {
        return this.session
            .clear()
            .then(() => {
            this.currentUser$.next(null);
            this.api.authData = null;
            return this.api
                .call({
                url: '/sessions/current',
                method: 'DELETE',
            })
                .toPromise();
        })
            .then(() => {
            this.isLoggedIn$.next(false);
            this.events.publish(UserEvent.UserDidLogout);
            this.store.dispatch(this.collectionActions.clearAll());
        });
    }
    // shift
    getCurrentFillerShift() {
        let request = this.api
            .call({
            url: '/filler_shifts?active=true',
            method: 'GET',
            ops: true,
        })
            .do(res => {
            if (res.length) {
                const shift = new FillerShiftModel(res[0]);
                this.currentFillerShift$.next(shift);
            }
            else {
                this.currentFillerShift$.next(null);
            }
        })
            .subscribe(new EmptySubscriber());
        return request;
    }
    // Private Methods
    setAuthData(data) {
        this.api.authData = data;
        return this.session.set(UserProvider_1.AUTH_DATA_KEY, data);
    }
};
// Session Keys
UserProvider.USER_DATA_KEY = 'current_user';
UserProvider.AUTH_DATA_KEY = 'auth';
UserProvider = UserProvider_1 = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiProvider,
        SessionProvider,
        Store,
        CollectionActions,
        Events])
], UserProvider);
export { UserProvider };
var UserProvider_1;
//# sourceMappingURL=user.js.map


// WEBPACK FOOTER //
// ./src/providers/user/user.ts.pre-build-optimizer.js